var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { margin: "0", padding: "0" } },
    [
      _vm.name === "Wifi"
        ? _c("Wifi", { attrs: { color: _vm.color } })
        : _vm.name === "Back"
        ? _c("Back", { attrs: { color: _vm.color } })
        : _vm.name === "Light"
        ? _c("Light", { attrs: { color: _vm.color } })
        : _vm.name === "Whells"
        ? _c("Whells", { attrs: { color: _vm.color } })
        : _vm.name === "Dart"
        ? _c("Dart", { attrs: { color: _vm.color } })
        : _vm.name === "Arrow"
        ? _c("Arrow", { attrs: { color: _vm.color } })
        : _vm.name === "PDF"
        ? _c("Pdf", { attrs: { color: _vm.color } })
        : _vm.name === "Triangle"
        ? _c("Triangle", { attrs: { color: _vm.color } })
        : _vm.name === "FullTime"
        ? _c("FullTime", { attrs: { color: _vm.color } })
        : _vm.name === "ManTime"
        ? _c("ManTime", { attrs: { color: _vm.color } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }